module.exports = __webpack_public_path__ + "img/JustLogo.986e45b7.svg";